import { Nodes } from 'hast';

/**
 * Drops the newline the parser writes after every line break.
 *
 * Markdown's HTML puts a `\n` after each `<br>`, so the markup reads well as source. A paragraph
 * here keeps runs of spaces with `white-space: pre-wrap` (see `markdownTheme.css`), and under that
 * rule the `\n` is a second line break: one press of return came out as a blank line, and read as
 * a new paragraph rather than a new line.
 */
export function rehypeBreakNewlines() {
  return (tree: Nodes) => trimAfterBreaks(tree);
}

function trimAfterBreaks(node: Nodes) {
  if (!('children' in node)) {
    return;
  }

  node.children.forEach((child, index) => {
    const previous = node.children[index - 1];
    if (child.type === 'text' && previous?.type === 'element' && previous.tagName === 'br') {
      child.value = child.value.replace(/^\n/, '');
    }
    trimAfterBreaks(child);
  });
}
